import { IPMatchedID } from '~/components/IPMatching/IPMatchingProvider';
import { ROUTES } from '~/constants';

export enum STATUS_LABELS {
  auto = 'Automatically',
  manual = 'Manually'
}

export const getIPMatchingPath = (campaignId: string) =>
  `${ROUTES.adminCampaign}/${campaignId}/ip-matching`;

export const getStudyLevelStatus = (key: string | null): string => {
  return key === null || key === 'migration'
    ? STATUS_LABELS.auto
    : STATUS_LABELS[key];
};

export const formatDuplicateIds = (errors?: string[] | string): string => {
  if (!!(errors?.length && Array.isArray(errors))) {
    const [, value] = errors[0].split(':');
    const formattedDuplicatesStr = value.replace(/[{}'']/g, '').trim();

    return formattedDuplicatesStr;
  }

  return '';
};

/**
 NOTE: 
 The following method compares both the client updated ids and api fetched ids.
 This helps ensure that when a user interacts with the IP Matching pagination component that the new list of ids is rendered correctly.
*/
export const findMatchingIdLists = (
  arr1: IPMatchedID[],
  arr2: IPMatchedID[]
): boolean => {
  if (!arr1.length || !arr2.length) return false;

  const set1 = new Set(arr1.map(obj => obj.lookup_key));
  const set2 = new Set(arr2.map(obj => obj.lookup_key));

  if (set1.size !== set2.size) {
    return false;
  }

  for (const key of set1) {
    if (!set2.has(key)) {
      return false;
    }
  }

  return true;
};
